import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class SupplierItem extends Component {
  static propTypes = {
    supplier: PropTypes.object.isRequired,
  }



  render() {
    const { supplier } = this.props

 
    return (
            <div className="techcontent">
            <h3>Company: {supplier.company_name}</h3>
            <div>{supplier.idx} Name: {supplier.name}<br/>
            Address: {supplier.address}, {supplier.city}, {supplier.state}<br/>
            Phone: {supplier.phone}<br/>
            Email: {supplier.email}<br/><br/><br/></div>
        </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupplierItem.js